module.exports = __webpack_public_path__ + "static/img/max_pictgrid30_1080x841.2bd170b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid30_1080x841.jpg
// module id = wI+K
// module chunks = 0